@if (forbiddenViewModel(); as model) {
  <section aria-labelledby="Synthèse contrat">
    <div class="ml-0 mb-2 mb-md-5 pt-1 pt-md-2">
      @if (model.title) {
        <h1 class="h2 mb-0 no-signature" data-e2e="forbidden-title">
          {{ model.title }}
        </h1>
      }
      @if (model.contractInfos; as infos) {
        <p class="text-gray3 d-flex flex-column">
          @if (infos.offerName || infos.publicLineNumber) {
            <span>{{ infos.offerName }} {{ infos.publicLineNumber }}</span>
          }
          @if (infos.city) {
            <span>{{ infos.city }}</span>
          }
          @if (infos.holderNameInfo) {
            <span>{{ infos.holderNameInfo }}</span>
          }
        </p>
      }
      @if (model?.subtitle) {
        <p class="pb-0 mb-0">
          {{ model?.subtitle }}
        </p>
      }
      @if (model?.detail) {
        <p>
          {{ model?.detail }}
        </p>
      }
      @if (model?.texts) {
        @for (text of model?.texts; track text) {
          <p>{{ text }}</p>
        }
      }
      @switch (model?.clientType) {
        @case ('SUGGESTED') {
          <suggested-component
            [viewModel]="model"
            (clickPrimaryButtonLink)="openPrimaryButtonLink($event, model)"
            (clickSecondaryButtonLink)="openSecondaryButtonLink($event, model)"
          ></suggested-component>
        }
        @case ('TERMINATED') {
          <terminated-component
            [viewModel]="model"
            [isDisabledEclair]="isDisabledEclairForbiddenLink"
            (clickPrimaryButtonLink)="openPrimaryButtonLink($event, model)"
            (clickSecondaryButtonLink)="openSecondaryButtonLink($event, model)"
          ></terminated-component>
        }
        @default {
          <default-button-component
            [viewModel]="model"
            (clickPrimaryButtonLink)="openPrimaryButtonLink($event)"
            (clickSecondaryButtonLink)="openSecondaryButtonLink($event)"
          ></default-button-component>
        }
      }
      @if (model.banner) {
        <forbidden-banner [model]="model.banner" (badgeClick)="openSecondaryButtonLink($event)"></forbidden-banner>
      }
    </div>
  </section>
}
